import store from "@/store";
import { setNav, getNav } from "@/assets/api/token.js";
export function getColumnAll() {
  let navTree = store.state.navTree; //栏目树
  let modelList = store.state.modelList; //模型

  if (navTree.length) {
    navTree = JSON.parse(getNav());
  }
  navTree.map((l) => {
    // 头部导航
    headNav.map((n) => {
      if (n.accessPath == l.accessPath) {
        n.id = l.id;
        n.name = l.name;
        n.subnav = l.children;
      }
    });
    //页面内容导航
    navList.map((n) => {
      if (n.accessPath == l.accessPath) {
        n.id = l.id;
        n.name = l.name;
        n.subnav = l.children;
      }
    });

    // 新闻
    if (l.accessPath == "/news") {
      newsTab.name = l.name;
      newsTab.tab = l.children;
      l.children.map((cl) => {
        footNav.map((f) => {
          if (cl.accessPath == f.accessPath) {
            f.name = cl.name;
            f.id = cl.id;
          }
        });
      });
    }
    //关于乌镇戏剧节
    if (l.accessPath == "/Introduction") {
      presidumTab.name = l.name;
      presidumTab.tab = l.children;
    }
    //与我们连接
    if (l.accessPath == "/contactUs") {
      presidumTab.tabUp = l.children;
    }

    //年度主题或年度活动
    if (l.accessPath == "/theme") {
      themeTab.name = l.name;
      themeTab.tab = l.children.filter((c) => {
        return (
          c.accessPath != "/articleRules" && //章程
          c.accessPath != "/theme" && //主题
          c.accessPath != "/themeTime" //演出时间表
        );
      });
      themeTab.tabUp = l.children.filter((c) => {
        return (
          c.accessPath == "/articleRules" || //章程
          c.accessPath == "/theme" || //主题
          c.accessPath == "/themeTime" //演出时间表
        );
      });

      // 青年竞演左侧菜单
      themeTab.tab.map((t) => {
        if (t.accessPath == "/youthCompeti") {
          youthCompetiLeft = t.children;
        }
        // console.log('youthCompetiLeft', youthCompetiLeft);
      });
      // 戏梦粮仓左侧菜单
      themeTab.tab.map((t) => {
        if (t.accessPath == "/dreamDrama") {
          dreamDramaLeft = t.children;
        }
      });
      // 对话小镇左侧菜单
      themeTab.tab.map((t) => {
        if (t.accessPath == "/townDialogue") {
          townLeft = t.children;
        }
      });
      // 嘉年华
      themeTab.tab.map((t) => {
        if (t.accessPath == "/Carnival") {
          carnivalLeft = t.children;
        }
      });
      // 喜剧空间
      themeTab.tab.map((t) => {
        if (t.accessPath == "/dramaSpace") {
          dramaSpaceLeft = t.children;
        }
      });
      // 喜剧集市
      themeTab.tab.map((t) => {
        if (t.accessPath == "/themeMarket") {
          themeMarketLeft = t.children;
        }
      });
    }
    // 了解更多
    if (l.accessPath == "/theater") {
      moreTab.name = l.name;
      moreTab.tab = l.children;
      l.children.map((cl) => {
        footNav.map((f) => {
          if (cl.accessPath == f.accessPath) {
            f.name = cl.name;
            f.id = cl.id;
          }
        });
      });
    }
    // 视频
    if (l.accessPath == "/videoList") {
      videoTab.name = l.name;
      videoTab.tab = l.children;
    }
  });
  return {
    navList,
    headNav,
    newsTab,
    presidumTab,
    videoTab,
    themeTab,
    moreTab,
    mediaTab,
    searchTab,
    partnerTab,
    footNav,
  };
}

export const headNav = [
  {
    name: "首页",
    accessPath: "/",
    tab: 0,
    id: 0,
  },
  {
    name: "乌镇戏剧节",
    accessPath: "/Introduction",
    tab: 2,
    subnav: [
      {
        name: "介绍与章程",
        accessPath: "/Introduction",
        tab: 14,
      },
      {
        name: "主席团",
        accessPath: "/predsidium",
        tab: 15,
      },
      {
        name: "艺术委员会",
        accessPath: "/activity",
        tab: 16,
      },
    ],
  },

  {
    name: "年度活动",
    accessPath: "/theme",
    tab: 4,
    subnav: [
      {
        name: "特邀剧目",
        accessPath: "/invitedPlay",
        tab: 21,
      },
      {
        name: "青年竞演",
        accessPath: "/youthCompeti",
        tab: 22,
      },
      {
        name: "古镇嘉年华",
        accessPath: "/Carnival",
        tab: 23,
      },
      {
        name: "小镇对话",
        accessPath: "/townDialogue",
        tab: 24,
      },
      {
        name: "戏梦粮仓",
        accessPath: "/dreamDrama",
        tab: 25,
      },
      {
        name: "戏剧空间",
        accessPath: "/dramaSpace",
        tab: 26,
      },
      {
        name: "戏剧集市",
        accessPath: "/themeMarket",
        tab: 27,
      },
      {
        name: "章程",
        accessPath: "/articleRules",
        tab: 28,
      },
      {
        name: "年度主题",
        accessPath: "/theme",
        tab: 29,
      },
      {
        name: "演出时间表",
        accessPath: "/themeTime",
        tab: 30,
      },
    ],
  },
];
export const navList = [
  {
    name: "首页",
    accessPath: "/",
    tab: 0,
    id: 0,
  },
  {
    name: "新闻资讯",
    accessPath: "/news",
    tab: 1,
    subnav: [
      {
        name: "新闻资讯",
        accessPath: "/news",
        tab: 12,
      },
      {
        name: "公告",
        accessPath: "/notice",
        tab: 13,
      },
    ],
  },
  {
    name: "乌镇戏剧节",
    accessPath: "/Introduction",
    tab: 2,
    subnav: [
      {
        name: "介绍与章程",
        accessPath: "/Introduction",
        tab: 14,
      },
      {
        name: "主席团",
        accessPath: "/predsidium",
        tab: 15,
      },
      {
        name: "艺术委员会",
        accessPath: "/activity",
        tab: 16,
      },
    ],
  },
  {
    name: "精彩视频",
    accessPath: "/videoList",
    tab: 3,
    subnav: [
      {
        name: "精彩视频",
        accessPath: "/videoList",
        tab: 20,
      },
    ],
  },
  {
    name: "年度活动",
    accessPath: "/theme",
    tab: 4,
    subnav: [
      {
        name: "特邀剧目",
        accessPath: "/invitedPlay",
        tab: 21,
      },
      {
        name: "青年竞演",
        accessPath: "/youthCompeti",
        tab: 22,
      },
      {
        name: "古镇嘉年华",
        accessPath: "/Carnival",
        tab: 23,
      },
      {
        name: "小镇对话",
        accessPath: "/townDialogue",
        tab: 24,
      },
      {
        name: "戏梦粮仓",
        accessPath: "/dreamDrama",
        tab: 25,
      },
      {
        name: "戏剧空间",
        accessPath: "/dramaSpace",
        tab: 26,
      },
      {
        name: "戏剧集市",
        accessPath: "/themeMarket",
        tab: 27,
      },
      {
        name: "章程",
        accessPath: "/articleRules",
        tab: 28,
      },
      {
        name: "年度主题",
        accessPath: "/theme",
        tab: 29,
      },
      {
        name: "演出时间表",
        accessPath: "/themeTime",
        tab: 30,
      },
    ],
  },
  {
    name: "了解更多",
    accessPath: "/theater",
    tab: 5,
    subnav: [
      {
        name: "剧场",
        accessPath: "/theater",
        tab: 31,
      },
      {
        name: "交通指南",
        accessPath: "/transGuide",
        tab: 32,
      },
      {
        name: "住宿指南",
        accessPath: "/travelBrochure",
        tab: 33,
      },
      {
        name: "地图",
        accessPath: "/map",
        tab: 34,
      },
      {
        name: "常见问题",
        accessPath: "/commonProblem",
        tab: 35,
      },
      {
        name: "周边纪念品",
        accessPath: "/memento",
        tab: 36,
      },
    ],
  },
  {
    name: "媒体注册",
    accessPath: "/mediaRegist",
    tab: 6,
  },
  {
    name: "全站搜索",
    accessPath: "/fullSearch",
    tab: 7,
  },
  {
    name: "合作伙伴",
    accessPath: "/partner",
    tab: 8,
  },
];
//新闻
export const newsTab = {
  name: "新闻资讯",
  eng: "NEWS",
  tab: [
    { name: "新闻资讯", cloumnId: 12, accessPath: "/news" },
    { name: "公告", cloumnId: 13, accessPath: "/notice" },
  ],
};
//乌镇戏剧节
export const presidumTab = {
  name: "关于乌镇戏剧节",
  eng: "ABOUT US",
  tabUp: [
    { name: "联系我们", cloumnId: 18, accessPath: "/contactUs" },
    { name: "支持我们", cloumnId: 19, accessPath: "/supportUs" },
  ],
  tab: [
    { name: "介绍与章程", cloumnId: 14, accessPath: "/Introduction" },
    { name: "主席团", cloumnId: 15, accessPath: "/presidium" },
    { name: "艺术委员会", cloumnId: 16, accessPath: "/ArtCommittee" },
    { name: "评委委员会", cloumnId: 17, accessPath: "/JudgingCommittee" },
  ],
};

//精彩视频
export const videoTab = {
  name: "精彩视频",
  eng: "VIDEOS",
  tab: [{ name: "视频种类", cloumnId: 20, accessPath: "/videoList" }],
};

//年度主题
export const themeTab = {
  name: "年度活动",
  eng: "THEME",
  tabUp: [
    { name: "章程", cloumnId: 28, accessPath: "/articleRules" },
    { name: "年度主题", cloumnId: 29, accessPath: "/theme" },
    { name: "演出时间表", cloumnId: 30, accessPath: "/themeTime" },
  ],
  tab: [
    { name: "特邀剧目", cloumnId: 21, accessPath: "/invitedPlay" },
    { name: "青年竞演", cloumnId: 22, accessPath: "/youthCompeti" },
    { name: "古镇嘉年华", cloumnId: 23, accessPath: "/Carnival" },
    { name: "小镇对话", cloumnId: 24, accessPath: "/townDialogue" },
    { name: "戏梦粮仓", cloumnId: 25, accessPath: "/dreamDrama" },
    { name: "戏剧空间", cloumnId: 26, accessPath: "/dramaSpace" },
    { name: "戏剧集市", cloumnId: 27, accessPath: "/themeMarket" },
  ],
};

//了解更多
export const moreTab = {
  name: "了解更多",
  eng: "KNOW MORE",
  tab: [
    { name: "剧场", cloumnId: 31, accessPath: "/theater" },
    { name: "交通指南", cloumnId: 32, accessPath: "/transGuide" },
    { name: "住宿指南", cloumnId: 33, accessPath: "/hotelGuide" },
    { name: "地图", cloumnId: 34, accessPath: "/map" },
    { name: "常见问题", cloumnId: 35, accessPath: "/commonProblem" },
    { name: "周边纪念品", cloumnId: 36, accessPath: "/memento" },
  ],
};

//媒体注册
export const mediaTab = {
  name: "媒体注册",
  eng: "Media registration",
  tab: [],
};
//全站搜索
export const searchTab = {
  name: "全站搜索",
  eng: "SEARCH",
  tab: [],
};
//合作伙伴
export const partnerTab = {
  name: "合作伙伴",
  eng: "PARENT",
  tab: [],
};
// 青年竞演左侧菜单
export let youthCompetiLeft = [
  { name: "资料下载" },
  { name: "章程" },
  { name: "报名细则" },
  { name: "报名Q&A" },
  { name: "入围名单" },
  { name: "剧目介绍" },
  { name: "赛程表" },
];
// 戏梦粮仓左侧菜单
export let dreamDramaLeft = [
  { name: "剧目介绍" },
  { name: "戏剧活动" },
  { name: "关于单元" },
];
// 对话小镇左侧菜单
export let townLeft = [
  { name: "小镇对话" },
  { name: "工作坊" },
  { name: "朗读会" },
  { name: "活动时间表" },
];
// 嘉年华左侧菜单
export let carnivalLeft = [
  { name: "资料下载" },
  { name: "征集说明" },
  { name: "报名Q&A" },
  { name: "入围名单" },
  { name: "嘉年华时间表" },
];
//喜剧空间左侧菜单
export let dramaSpaceLeft = [{ name: "活动内容" }, { name: "活动时间表" }];
export let themeMarketLeft = [{ name: "参与报名" }, { name: "活动内容" }];
export let footNav = [
  { name: "新闻资讯", accessPath: "/news" },
  { name: "交通信息", accessPath: "/transGuide" },
  { name: "剧场介绍", accessPath: "/theater" },
  { name: "纪念品", accessPath: "/memento" },
];
